import type { LookupNotifications, NotificationReport } from '@adc/sdk/types'
import fetch from '@adc/fetch'
import { gql } from '@adc/sdk'

export const fetchNotifications = (
  _req: unknown,
  filterOptions: {
    pageSize: number
    currentPage: number
  }
): Promise<LookupNotifications> => {
  const filters = {
    take: filterOptions.pageSize,
    page: filterOptions.currentPage - 1,
    sort: {
      field: 'notificationDisplayName',
      order: 'ASC',
    },
  }
  return fetch
    .forAuctionGraph<'notifications', LookupNotifications>({
      variables: { filters },
      query: gql`
        query morpheus_fetchNotifications(
          $filters: LookupNotificationsFilters
        ) {
          notifications(filters: $filters) {
            current_page
            total_count
            total_pages
            content {
              asset_type
              config {
                channel
                is_active
              }
              notification_code
              notification_description
              notification_display_name
              notification_id
              purpose_type
              trigger_description
            }
          }
        }
      `,
    })
    .then(response => {
      if (response.body.errors && response.body.errors[0]) {
        throw response.body.errors[0]
      }
      return response.body.data.notifications
    })
}

export const getNotificationsReport = (
  notificationId: string
): Promise<NotificationReport> => {
  return fetch
    .forAuctionGraph<'notification_report', NotificationReport[]>({
      variables: {
        input: {
          notification_ids: [notificationId],
        },
      },
      query: gql`
        query morpheus_fetchNotificationsReport(
          $input: NotificationReportRequest!
        ) {
          notification_report(input: $input) {
            notification_id
            notification_code
            channel_aggregations {
              send_date
              total_count
              channel_type
              status
            }
          }
        }
      `,
    })
    .then(response => {
      if (response.body.errors && response.body.errors[0]) {
        throw response.body.errors[0]
      }
      return response.body.data.notification_report[0]
    })
}
